export function pluralPharmaciesText(counter: number) {
	let txt;
	let count = counter % 100;

	if (count >= 5 && count <= 20) {
		txt = "аптек";
	} else {
		count = count % 10;
		if (count == 1) {
			txt = "аптека";
		} else if (count >= 2 && count <= 4) {
			txt = "аптеки";
		} else {
			txt = "аптек";
		}
	}
	return txt;
}
